import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";

type Props = {};

export const StatusFilter = ({}: Props) => {
	const {
		state: { statusCodes },
	} = useAssetDetailsContext();
	const [searchParams, setSearchParams] = useSearchParams();
	const status = searchParams.get("status") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("status", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box
			sx={{
				"& .MuiSelect-select": {
					backgroundColor: "#FFF",
					paddingTop: "6px",
					paddingBottom: "6px",
				},
			}}
		>
			<FormControl variant="outlined" size="small" sx={{ width: "100%" }}>
				<InputLabel id="status-select-label">Status</InputLabel>
				<Select
					labelId="status-select-label"
					id="status-select"
					value={status}
					onChange={handleFilter}
					label="Status"
				>
					{statusCodes.map((status) => {
						return (
							<MenuItem
								sx={{ paddingBottom: 0 }}
								key={`logId-${status.id}`}
								value={status.id}
							>
								{status.description}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
